import { render, staticRenderFns } from "./CreateStoragePlace.vue?vue&type=template&id=af3a9f86"
import script from "./CreateStoragePlace.vue?vue&type=script&lang=js"
export * from "./CreateStoragePlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports